import React, { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Box, Text } from "@chakra-ui/react";

import TextInput from "components/TextInput";
import Textarea from "components/Textarea";
import Button from "components/Button";
import ContactInstance from "services/contact";
import axios from "axios";

const initialValues = {
  name: "",
  email: "",
  message: "",
};

const fieldNames = {
  name: "name",
  email: "email",
  message: "message",
};

interface Props {
  setSentEmail: (value: boolean) => void;
  setError: (value: boolean) => void;
  refSuccessfullyMessage: any;
  refErrorMessage: any;
}

const FormContact = ({
  refSuccessfullyMessage,
  setSentEmail,
  refErrorMessage,
  setError,
}: Props) => {
  const [sendingEmail, setSendingEmail] = useState<boolean>(false);

  const handleSubmitEmailApi = async (values) => {
    setSendingEmail(true);
    try {
      const responseGetToken = await ContactInstance.getToken();
      const token = responseGetToken.access_token;
      if (token) {
        const bodySendMailFormData = new FormData();
        bodySendMailFormData.append(fieldNames.name, values.name);
        bodySendMailFormData.append(fieldNames.email, values.email);
        bodySendMailFormData.append(fieldNames.message, values.message);
        await ContactInstance.sendMail({ body: bodySendMailFormData, token });
        setSendingEmail(false);
        setSentEmail(true);
        formik.resetForm();
      }
    } catch (error) {
      setSendingEmail(false);
      setError(true);
      formik.resetForm();
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: yup.object().shape({
      name: yup.string().trim().required("Please provide your full name."),
      email: yup
        .string()
        .email("Invalid email address.")
        .required("Please provide your email address."),
      message: yup
        .string()
        .trim()
        .required("Please provide more information on how we can help you."),
    }),
    onSubmit: handleSubmitEmailApi,
  });

  return (
    <form onSubmit={formik.handleSubmit as any}>
      <Box mb="34px" position="relative">
        <TextInput
          padding={["0 8px", null, null, "0 16px"]}
          label="Name*"
          name={fieldNames.name}
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          border={
            formik.touched.name && formik.errors.name
              ? "1px solid #ff0000"
              : "none"
          }
        />
        {formik.touched.name && formik.errors.name && (
          <Text
            position="absolute"
            color="#ff0000"
            mt="4px"
            fontSize={["14px", null, null, "16px"]}
          >
            {formik.errors.name}
          </Text>
        )}
      </Box>
      <Box mb="34px" position="relative">
        <TextInput
          padding={["0 8px", null, null, "0 16px"]}
          label="Business Email*"
          name={fieldNames.email}
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          border={
            formik.touched.email && formik.errors.email
              ? "1px solid #ff0000"
              : "none"
          }
        />
        {formik.touched.email && formik.errors.email && (
          <Text
            position="absolute"
            color="#ff0000"
            mt="4px"
            fontSize={["14px", null, null, "16px"]}
          >
            {formik.errors.email}
          </Text>
        )}
      </Box>
      <Box mb="34px" position="relative">
        <Textarea
          minHeight={["182px", null, null, null, null, "215px"]}
          padding={["8px", null, null, "8px 16px"]}
          label="What we can help you with?*"
          name={fieldNames.message}
          value={formik.values.message}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          border={
            formik.touched.message && formik.errors.message
              ? "1px solid #ff0000"
              : "none"
          }
        />
        {formik.touched.message && formik.errors.message && (
          <Text
            position="absolute"
            color="#ff0000"
            mt="4px"
            fontSize={["14px", null, null, "16px"]}
          >
            {formik.errors.message}
          </Text>
        )}
      </Box>
      <Button
        mt={["37px", null, null, null, null, "0px"]}
        w="100%"
        fontSize={["12px", null, null, null, null, "16px"]}
        isLoading={sendingEmail}
        type="submit"
        _hover={{ bg: "primary" }}
      >
        Send
      </Button>
    </form>
  );
};

export default FormContact;
